module.exports = __webpack_public_path__ + "static/img/bak4.772ec8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/ing1/bak4.png
// module id = yq75
// module chunks = 0